export const borderRadius = {
  none: '0',
  small: '4px',
  medium: '8px',
  large: '16px',
  full: '999px',
} as const;
